'use client'
import React from 'react'

export interface GridRowProps extends React.HTMLAttributes<HTMLDivElement> {
    columns?: number
    gap?: 2 | 4 | 6
    children: JSX.Element | JSX.Element[]
}

export const GridRow = ({ columns, gap = 6, children, ...props }: GridRowProps): JSX.Element => {
    const defaultClasses = 'grid gap-6'
    const gapClasses = `gap-${gap}`
    let columnClasses = columns ? `columns-${columns}` : ''
    const propClasses = props.className ?? ''

    const combinedClasses = [defaultClasses, columnClasses, gapClasses, propClasses].join(' ')

    return (
        <div {...props} className={combinedClasses}>
            {children}
        </div>
    )
}
